import React, { useEffect } from "react";
import { useFormik } from "formik";
import { validationSchema } from "./validationSchema";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";
import CloseIcon from "../../assets/close.svg";
import useList from "../../controller/list-controller";
import PageHeader from "../../components/table/pageHeader/PageHeader";
import FormInput from "../../components/form/FormInput";
import FormSelect from "../../components/form/FormSelect";
import FmiCases from "../../assets/sidebar/fmiCases";
import { convertToBlob, getFileName } from "../../utils/helper";
import Button from "../../components/buttton/button";
import useCase from "../../controller/case-controller";
import { useNavigate } from "react-router-dom";
import { useDialogContext } from "../../components/dialogs/Dialog";
import { useBottomSheetContext } from "../../components/dialogs/bottomsheet";
import DateSvg from "../../assets/DateSvg";

const FmiCasesCreate = () => {
  const navigate = useNavigate();
  const { succMsg, errMsg, isLoading, createCase } = useCase();
  const {
    allConst,
    errMsg: errMsg2,
    isLoading: isLoading2,
    getConstants,
  } = useList();
  const { dispatch } = useDialogContext();
  const { dispatch: dis } = useBottomSheetContext();

  const formik = useFormik({
    initialValues: {
      accountId: "",
      accountName: "",
      productId: "",
      productName: "",
      dateOfComplaint: "",
      productQuantity: 0,
      type: "",
      subType: "",
      priority: "Medium",
      description: "",
      attachments: [],
    },
    validationSchema,
    enableReinitialize: false,
    onSubmit: async (values) => {
      const files = [];
      for (let i = 0; i < values?.attachments?.length; i++) {
        if (values?.attachments[i]?.name) {
          let blob = await convertToBlob(values?.attachments[i]);
          files.push({
            title: getFileName(values?.attachments?.[i]?.name),
            fullName: values?.attachments?.[i]?.name,
            versionData: blob,
          });
        }
      }

      createCase({
        ...values,
        attachments: files,
      });
    },
  });

  useEffect(() => {
    if (allConst) {
      formik.setFieldValue("dateOfComplaint", allConst?.dateOfComplaint, true);
    }
  }, [allConst]);

  useEffect(() => {
    if (formik.values.accountId) {
      getConstants({
        objectName: "case",
        accountId: formik.values.accountId,
      });
    }
  }, [formik.values.accountId]);

  useEffect(() => {
    if (succMsg) {
      toast.success(succMsg);
      formik.resetForm();
    }
  }, [succMsg]);

  useEffect(() => {
    if (errMsg || errMsg2) {
      toast.error(errMsg || errMsg2);
    }
  }, [errMsg || errMsg2]);

  const onDrop = (files, r, name) => {
    if (files.length) {
      const blob = new Blob(files, {
        type: files[0]?.type,
      });
      blob.name = files[0]?.name;
      formik.setFieldValue(
        `attachments[${formik.values?.attachments?.length}]`,
        blob,
        true
      );
    }
  };

  return (
    <div className="step2-container flex flex-col h-full justify-end align-end">
      <PageHeader
        svg={<FmiCases color="white" width="24" height="24" />}
        text="Case"
        subTitle={"Create Case"}
        isBackBtn={true}
        onBackClick={() => navigate("/orders")}
      />
      <div
        className="order-create-container md:p-4 md:rounded-lg h-full !overflow-x-hidden overflow-y-auto"
        id="scroll-div"
      >
        <form id="createCaseForm" onSubmit={formik.handleSubmit}>
          <div className="w-full">
            <div className="title font-semibold text-base	md:rounded-lg py-3.5 px-4">
              Information
            </div>
            <div>
              <div className="grid md:rounded-b-lg py-6 px-4 pb-6 ">
                <div className="grid md:grid-cols-2 ">
                  <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Date of Complaint
                      <span className="asterisk-label ml-1">*</span>
                    </div>
                    <div className="md:ml-8 col-span-2">
                      <FormInput
                        dom={{
                          name: "dateOfComplaint",
                          type: "date",
                          className: "p-2.5 border-grey-1900",
                          readOnly: true,
                          disabled: true,
                          value: formik?.values?.dateOfComplaint,
                          onChange: () => {},
                        }}
                        preFix={() => <DateSvg className="absolute right-3" />}
                        fullwidth={true}
                        error={
                          !formik.values.accountId ||
                          (formik.touched.dateOfComplaint &&
                            Boolean(formik.errors.dateOfComplaint))
                        }
                        errorMessage={
                          formik.values.accountId
                            ? formik.touched.dateOfComplaint
                              ? formik.errors.dateOfComplaint
                              : ""
                            : ""
                        }
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-3 md:ml-4 md:mb-0">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Account<span className="asterisk-label ml-1">*</span>
                    </div>
                    <div className="md:ml-8 col-span-2 md:block hidden">
                      <FormInput
                        dom={{
                          type: "text",
                          name: "accountName",
                          placeholder: "Account",
                          className: "p-2.5 border-grey-1900",
                          value: formik?.values?.accountName,
                          onClick: () => {
                            dispatch({
                              type: "openDialog",
                              payload: {
                                data: {
                                  handleAddName: (values) => {
                                    formik?.setFieldValue(
                                      "accountId",
                                      values?.accountId
                                    );
                                    formik?.setFieldValue(
                                      "accountName",
                                      values?.accountName
                                    );
                                  },
                                  footer: true,
                                  cancelBtn: true,
                                  isSearch: true,
                                  title: "Accounts",
                                  buttonText: {
                                    submit: "Save",
                                  },
                                  className: "!p-0",
                                },
                                path: `orders/AccountsList`,
                              },
                            });
                          },
                        }}
                        className={"py-0 border-grey-1900"}
                        fullwidth={true}
                        error={
                          formik.touched.accountName &&
                          Boolean(formik.errors.accountName)
                        }
                        errorMessage={
                          formik.touched.accountName &&
                          formik.errors.accountName
                        }
                      />
                    </div>
                    <div
                      className="md:ml-8 col-span-2 md:hidden block"
                      onClick={() => {
                        dis({
                          type: "openBottomSheet",
                          payload: {
                            data: {
                              modalType: "list",
                              handleAddName: (values) => {
                                formik?.setFieldValue(
                                  "accountId",
                                  values?.accountId
                                );
                                formik?.setFieldValue(
                                  "accountName",
                                  values?.accountName
                                );
                              },
                              footer: true,
                              cancelBtn: true,
                              isSearch: true,
                              title: "Accounts",
                              buttonText: {
                                submit: "Save",
                              },
                              className: "!p-0",
                            },
                            path: `orders/AccountsList`,
                          },
                        });
                      }}
                    >
                      <FormInput
                        dom={{
                          type: "text",
                          name: "accountName",
                          placeholder: "Account",
                          className: "p-2.5 border-grey-1900",
                          value: formik?.values?.accountName,
                          readOnly: true,
                        }}
                        className={"py-0 border-grey-1900"}
                        fullwidth={true}
                        error={
                          formik.touched.accountName &&
                          Boolean(formik.errors.accountName)
                        }
                        errorMessage={
                          formik.touched.accountName &&
                          formik.errors.accountName
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="title font-semibold text-base	md:rounded-lg py-3.5 px-4">
              Additional Information
            </div>
            <div>
              <div className="grid md:rounded-b-lg py-6 px-4">
                <div className="grid md:grid-cols-2 md:mb-5">
                  <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Type<span className="asterisk-label ml-1">*</span>
                    </div>
                    <div className="md:ml-8 col-span-2 pr-0.5">
                      <FormSelect
                        name="type"
                        className={"py-0 border-grey-1900"}
                        labelClass="text-lg text-grey-500"
                        fullwidth={true}
                        isDisabled={!formik.values.accountId}
                        onChange={(value) => {
                          formik.setFieldValue("type", value?.value);
                          formik.setFieldValue("subType", "");
                        }}
                        options={
                          allConst?.type?.length > 0
                            ? allConst?.type?.map((dt) => ({
                                label: dt,
                                value: dt,
                              }))
                            : []
                        }
                        value={{
                          label: formik?.values?.type,
                          value: formik?.values?.type,
                        }}
                        error={
                          !formik.values.accountId ||
                          (formik.touched.type && Boolean(formik.errors.type))
                        }
                        errorMessage={
                          formik.values.accountId
                            ? formik.touched.type
                              ? formik.errors.type
                              : ""
                            : "Please select account to select type."
                        }
                        isClearable={false}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-3 md:ml-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Product
                      {/* <span className="asterisk-label ml-1">*</span> */}
                    </div>
                    <div className="md:ml-8 col-span-2 pr-0.5 md:block hidden">
                      <FormInput
                        dom={{
                          type: "text",
                          name: "productName",
                          placeholder: "Product",
                          className: "p-2.5 border-grey-1900",
                          disabled: !formik.values.accountId,
                          value: formik?.values?.productName,
                          onClick: () => {
                            dispatch({
                              type: "openDialog",
                              payload: {
                                data: {
                                  handleAddName: (values) => {
                                    formik?.setFieldValue(
                                      "productId",
                                      values?.productId
                                    );
                                    formik?.setFieldValue(
                                      "productName",
                                      values?.productName
                                    );
                                  },
                                  footer: true,
                                  cancelBtn: true,
                                  isSearch: true,
                                  title: "Products",
                                  buttonText: {
                                    submit: "Save",
                                  },
                                  className: "!p-0",
                                },
                                path: `orders/ProductList`,
                              },
                            });
                          },
                        }}
                        className={"py-0 border-grey-1900"}
                        fullwidth={true}
                        error={
                          !formik.values.accountId ||
                          (formik.touched.productName &&
                            Boolean(formik.errors.productName))
                        }
                        errorMessage={
                          formik.values.accountId
                            ? formik.errors.productName
                            : "Please select account to select product."
                        }
                      />
                    </div>
                    <div
                      className="md:ml-8 col-span-2 pr-0.5 md:hidden block"
                      onClick={() => {
                        dis({
                          type: "openBottomSheet",
                          payload: {
                            data: {
                              modalType: "list",
                              handleAddName: (values) => {
                                formik?.setFieldValue(
                                  "productId",
                                  values?.productId
                                );
                                formik?.setFieldValue(
                                  "productName",
                                  values?.productName
                                );
                              },
                              footer: true,
                              cancelBtn: true,
                              isSearch: true,
                              title: "Products",
                              buttonText: {
                                submit: "Save",
                              },
                              className: "!p-0",
                            },
                            path: `orders/ProductList`,
                          },
                        });
                      }}
                    >
                      <FormInput
                        dom={{
                          type: "text",
                          name: "productName",
                          placeholder: "Product",
                          className: "p-2.5 border-grey-1900",
                          disabled: !formik.values.accountId,
                          value: formik?.values?.productName,
                          readOnly: true,
                        }}
                        className={"py-0 border-grey-1900"}
                        fullwidth={true}
                        error={
                          !formik.values.accountId ||
                          (formik.touched.productName &&
                            Boolean(formik.errors.productName))
                        }
                        errorMessage={
                          formik.values.accountId
                            ? formik.errors.productName
                            : "Please select account to select product."
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="grid md:grid-cols-2 md:mb-5 mb-4">
                  <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Sub Type<span className="asterisk-label ml-1">*</span>
                    </div>
                    <div className="md:ml-8 col-span-2 pr-0.5">
                      <FormSelect
                        name="type"
                        className={"py-0 border-grey-1900"}
                        labelClass="text-lg text-grey-500"
                        fullwidth={true}
                        isDisabled={!formik.values.type}
                        onChange={(value) => {
                          formik.setFieldValue("subType", value?.value);
                        }}
                        options={
                          allConst?.subType?.[formik.values.type]?.length > 0
                            ? allConst?.subType?.[formik.values.type]?.map(
                                (dt) => ({
                                  label: dt,
                                  value: dt,
                                })
                              )
                            : []
                        }
                        value={{
                          label: formik?.values?.subType,
                          value: formik?.values?.subType,
                        }}
                        error={
                          !formik.values.type ||
                          (formik.touched.subType &&
                            Boolean(formik.errors.subType))
                        }
                        errorMessage={
                          formik.values.type
                            ? formik.errors.subType
                            : "Please select type to select sub type."
                        }
                        isClearable={false}
                        isSearchable={false}
                      />
                    </div>
                    {/* <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Priority
                    </div>
                    <div className="md:ml-8 col-span-2 pr-0.5">
                      <FormSelect
                        name="priority"
                        className={"py-0 border-grey-1900"}
                        fullwidth={true}
                        isDisabled={!formik.values.accountId}
                        options={
                          allConst?.priority?.length > 0
                            ? allConst?.priority?.map((dt) => ({
                                label: dt,
                                value: dt,
                              }))
                            : []
                        }
                        value={{
                          label: formik?.values?.priority,
                          value: formik?.values?.priority,
                        }}
                        onChange={(e) => {
                          if (e)
                            formik.setFieldValue("priority", e?.value, true);
                        }}
                        error={
                          !formik.values.accountId ||
                          (formik.touched.priority &&
                            Boolean(formik.errors.priority))
                        }
                        errorMessage={
                          formik.values.accountId
                            ? formik.touched.priority
                              ? formik.errors.priority
                              : ""
                            : "Please select account to select priority."
                        }
                        isClearable={false}
                        isSearchable={false}
                      />
                    </div> */}
                  </div>
                  <div className="grid md:grid-cols-3 md:ml-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Product Quantity
                    </div>
                    <div className="md:ml-8 col-span-2 pr-0.5">
                      <FormInput
                        dom={{
                          name: "productQuantity",
                          type: "number",
                          value: formik?.values?.productQuantity,
                          onChange: formik?.handleChange,
                          className: "p-2.5 border-grey-1900",
                        }}
                        fullwidth={true}
                        error={
                          formik.touched.productQuantity &&
                          Boolean(formik.errors.productQuantity)
                        }
                        errorMessage={
                          formik.touched.productQuantity &&
                          formik.errors.productQuantity
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="grid md:grid-cols-2">
                  <div className="grid md:grid-cols-3 md:mr-4 md:mb-0 mb-4">
                    <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                      Priority
                    </div>
                    <div className="md:ml-8 col-span-2 pr-0.5">
                      <FormSelect
                        name="priority"
                        className={"py-0 border-grey-1900"}
                        fullwidth={true}
                        isDisabled={!formik.values.accountId}
                        options={
                          allConst?.priority?.length > 0
                            ? allConst?.priority?.map((dt) => ({
                                label: dt,
                                value: dt,
                              }))
                            : []
                        }
                        value={{
                          label: formik?.values?.priority,
                          value: formik?.values?.priority,
                        }}
                        onChange={(e) => {
                          if (e)
                            formik.setFieldValue("priority", e?.value, true);
                        }}
                        error={
                          !formik.values.accountId ||
                          (formik.touched.priority &&
                            Boolean(formik.errors.priority))
                        }
                        errorMessage={
                          formik.values.accountId
                            ? formik.touched.priority
                              ? formik.errors.priority
                              : ""
                            : "Please select account to select priority."
                        }
                        isClearable={false}
                        isSearchable={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="title font-semibold text-base	md:rounded-lg py-3.5 px-4">
              Description Information
            </div>
            <div>
              <div className="grid md:rounded-b-lg py-6 px-4">
                <div className="grid md:grid-cols-6">
                  <div className="fieldName font-normal text-sm flex items-center md:mb-0 mb-2">
                    Description
                  </div>
                  <div className="md:ml-7 col-span-5">
                    <FormInput
                      dom={{
                        type: "text",
                        name: "description",
                        className: "p-2.5 border-grey-1900",
                        value: formik?.values?.description,
                        onChange: (e) =>
                          formik.setFieldValue(
                            "description",
                            e?.target?.value,
                            true
                          ),
                      }}
                      fullwidth={true}
                      error={
                        formik.touched.description &&
                        Boolean(formik.errors.description)
                      }
                      errorMessage={
                        formik.touched.description && formik.errors.description
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="title font-semibold text-base	md:rounded-lg py-3.5 px-4">
              Attachment Information
            </div>
            <div>
              <div className="grid md:rounded-b-lg py-6">
                <div className="grid md:grid-cols-6">
                  <div className="fieldName font-normal text-sm flex flex-col px-4">
                    <div className="mb-1">File</div>
                    <div className="asterisk-label text-xs">
                      There is a file limit of five, and only one file of less
                      than 500 kb is permitted at times.
                    </div>
                  </div>
                  <div className="md:m-0 m-5 md:ml-7 col-span-5 ">
                    <Dropzone
                      multiple={true}
                      onDrop={(accepted, rejected) => {
                        if (formik.values?.attachments?.length === 5) {
                          toast.error("Maximum % attachments allowed.");
                        }

                        accepted?.map((accept) => {
                          if (accept?.size <= 500000) {
                            onDrop([accept], rejected);
                          } else {
                            toast.error(
                              `${accept?.name} size should be below 500kb`
                            );
                          }
                        });
                      }}
                      name="attachments"
                      className="dnd-input w-full border-2 border-dashed border-grey-600 md:rounded-md	"
                    >
                      <p className="absolute-center">
                        Drag & drop some files here, or click to select files
                      </p>
                    </Dropzone>

                    <div className="flex flex-wrap gap-5 mt-3">
                      {formik.values?.attachments?.length > 0
                        ? formik.values?.attachments?.map(
                            (attachment, index) => {
                              return (
                                <p className="flex  items-center">
                                  {attachment?.name}
                                  <span
                                    className="deleteBtn cursor-pointer ml-2"
                                    onClick={() =>
                                      formik.setFieldValue(
                                        `attachments`,
                                        formik.values?.attachments?.filter(
                                          (_, i) => {
                                            return i !== index;
                                          }
                                        ),
                                        true
                                      )
                                    }
                                  >
                                    <img
                                      src={CloseIcon}
                                      alt="close"
                                      height={10}
                                      width={10}
                                    />
                                  </span>
                                </p>
                              );
                            }
                          )
                        : ""}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white-100 flex flex-row justify-end md:mb-0 md:mt-6 md:px-0 py-3 px-4 md:static fixed bottom-0 left-0 right-0">
            <button
              type="button"
              className="btn btn-primary-outlined bg-white-100 mx-1.5 capitalize"
              onClick={() => navigate("/fmi-cases")}
              disabled={isLoading || isLoading2}
            >
              Cancel
            </button>
            <Button
              type="submit"
              className="btn btn-primary disabled:!bg-red-900 md:w-10 !w-fit ml-1.5 capitalize"
              disabled={isLoading || isLoading2 || !formik.values.accountId}
              loader={isLoading}
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FmiCasesCreate;
